module.exports = __webpack_public_path__ + "img/noData.efc82539.png";